module.exports = __webpack_public_path__ + "img/27.102384b3.jpg";